import z from "zod";
import moment from "moment";
import {
  getServiceRequestMinDate,
  getServiceRequestMaxDate,
} from "utils/date";
import { addressSchemaField } from "./address";

export const SERVICE_REQUEST_STATUS = {
  pending: "Pending",
  assigned: "Assigned",
  inProgress: "In progress",
  visitCompleted: "Visit completed",
  completed: "Request completed",
  active: "Active",
  declined: "Declined",
  draft: "Draft",

  displayValue: (status) => {
    switch (status) {
      case SERVICE_REQUEST_STATUS.declined:
        return "Canceled";
      default:
        return status;
    }
  },
  values: () => [
    SERVICE_REQUEST_STATUS.pending,
    SERVICE_REQUEST_STATUS.completed,
    SERVICE_REQUEST_STATUS.assigned,
    SERVICE_REQUEST_STATUS.inProgress,
    SERVICE_REQUEST_STATUS.active,
    SERVICE_REQUEST_STATUS.visitCompleted,
    SERVICE_REQUEST_STATUS.declined,
    SERVICE_REQUEST_STATUS.draft,
  ],
  options: () => [
    ...[
      SERVICE_REQUEST_STATUS.pending,
      SERVICE_REQUEST_STATUS.assigned,
      SERVICE_REQUEST_STATUS.inProgress,
      SERVICE_REQUEST_STATUS.visitCompleted,
      SERVICE_REQUEST_STATUS.completed,
      SERVICE_REQUEST_STATUS.declined,
    ].map((status) => ({
      value: status,
      label: SERVICE_REQUEST_STATUS.displayValue(status),
    })),
  ],
};

export const serviceRequestDateSchemaField = z.custom(
  (val) => {
    if (!val || !moment.isMoment(val)) return false;
    return (
      val.isSameOrAfter(getServiceRequestMinDate(), "day") &&
      val.isSameOrBefore(getServiceRequestMaxDate(), "day")
    );
  },
  {
    message:
      "Please select a date from today through the next three months.",
  },
);

export const serviceRequestTimesSchemaField = z
  .custom(
    (val) => {
      return (
        val &&
        Array.isArray(val) &&
        val.length === 2 &&
        val.every((item) => item && moment.isMoment(item))
      );
    },
    { message: "Please fill in start time and end time" },
  )
  .superRefine(([startTime, endTime], ctx) => {
    const diff = endTime.diff(startTime, "minutes");
    if (diff < 30)
      ctx.addIssue({
        code: "custom",
        message: "Time period is shorter than 0.5h",
      });
    else if (diff > 240)
      ctx.addIssue({
        code: "custom",
        message: "Time period is longer than 4h",
      });
    else if (diff % 30 !== 0)
      ctx.addIssue({
        code: "custom",
        message: "Overall time period should be a multiple of 30 mins",
      });
  });

export const serviceRequestVisitTypeSchemaField = z.preprocess(
  (val) => val || "",
  z.string().min(1, { message: "Visit type is required" }),
);
export const serviceRequestAddressSchemaField = addressSchemaField;

export const serviceRequestSuiteSchemaField = z
  .string()
  .trim()
  .max(12, { message: "Suite must be less than 12 characters" })
  .nullish();

export const serviceRequestCommentSchemaField = z
  .string()
  .trim()
  .max(5000, { message: "Notes must be less than 5000 characters" })
  .nullish();

export const serviceRequestSchemaToJsonTranform = (value) => {
  return {};
};

export const serviceRequestFromJson = (json) => {
  return {};
};
